import React from 'react';
import classnames from 'classnames';

import { Participant } from '@app/api';
import { CellProps } from 'react-table';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  red: {
    color: theme.colors.redAccessible,
  },
}));

export const RedExcludedCell = (props: CellProps<Participant, string>) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const excluded = !!(
    props.row &&
    props.row.original &&
    props.row.original.excluded
  );

  return (
    <span
      className={classnames({
        [classes.red]: excluded,
      })}
    >
      {props.value}
    </span>
  );
};
